import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useAuth } from '../module_roots/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "../module_mechanics/Styles/FormList.css";
import {
    faEdit, faTrash, faSave, faSearch, faRefresh, faSpinner, faEye, faTimesCircle, faDollarSign, faBalanceScale, faCalculator,
    faExclamationTriangle, faCheckCircle, faTimes, faChevronLeft,
    faChevronRight, faFilePdf, faCalendar, faUser, faStore, faPhone,
    faEnvelope, faMapMarkerAlt, faTag, faExchangeAlt, faChevronDown,
    faExpand, faCompress, faArrowsAlt, faMinus, faPlus, faFilter, faEyeSlash,
    faTruck, faBuilding, faGlobe, faUserTag, faStickyNote, faExternalLinkAlt,
    faBoxes, faBox, faCubes, faBoxOpen, faLayerGroup, faIndustry, faHashtag, faBarcode,
    faCreditCard, faPalette, faRulerCombined, faWarehouse, faCubes as faCubesIcon, faTag as faTagIcon
} from '@fortawesome/free-solid-svg-icons';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

// ============================================
// SHARED TRANSLATOR FOR PRODUCT LIST
// ============================================
const createProductListTranslator = () => {
    let cache = new Map();

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) { }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_translations', JSON.stringify(cacheObj));
        } catch (e) { }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;

        const dict = {
            'ur': {
                'Products List': 'مصنوعات کی فہرست',
                'All products details are below': 'تمام مصنوعات کی تفصیلات نیچے ہیں',
                'Product Name': 'پروڈکٹ کا نام',
                'Category': 'زمرہ',
                'Company': 'کمپنی',
                'Color': 'رنگ',
                'Size': 'سائز',
                'Batch Number': 'بیچ نمبر',
                'Barcode': 'بارکوڈ',
                'Quantity': 'مقدار',
                'BQuantity': 'بلک مقدار',
                'Cost Price': 'لاگت قیمت',
                'Selling Price': 'فروخت قیمت',
                'Unit': 'یونٹ',
                'Actions': 'اعمال',
                'Added By': 'شامل کرنے والا',
                'Search products...': 'مصنوعات تلاش کریں...',
                'Refresh': 'ریفریش کریں',
                'Export PDF': 'پی ڈی ایف ایکسپورٹ کریں',
                'Edit': 'ترمیم کریں',
                'Delete': 'حذف کریں',
                'Close': 'بند کریں',
                'Save Changes': 'تبدیلیاں محفوظ کریں',
                'Cancel': 'منسوخ کریں',
                'Success': 'کامیابی',
                'Error': 'خرابی',
                'Warning': 'انتباہ',
                'Showing': 'دکھا رہا ہے',
                'of': 'میں سے',
                'Previous': 'پچھلا',
                'Next': 'اگلا',
                'All': 'سب',
                'Product Details': 'پروڈکٹ کی تفصیلات',
                'Stock Information': 'اسٹاک کی معلومات',
                'Packing Information': 'پیکنگ کی معلومات',
                'No shop selected': 'کوئی شاپ منتخب نہیں',
                'Please select a shop to view products': 'براہ کرم مصنوعات دیکھنے کے لیے شاپ منتخب کریں',
                'S.No': 'نمبر',
                'Products': 'مصنوعات',
                'Shop': 'شاپ',
                'View': 'دیکھیں',
                'Update Product': 'پروڈکٹ اپڈیٹ کریں',
                'Updating...': 'اپڈیٹ ہو رہا ہے...',
                'Product updated successfully': 'پروڈکٹ کامیابی سے اپڈیٹ ہو گئی',
                'Error updating product': 'پروڈکٹ اپڈیٹ کرنے میں خرابی',
                'Confirm Delete': 'حذف کرنے کی تصدیق',
                'Yes, Delete': 'ہاں، حذف کریں',
                'No, Cancel': 'نہیں، منسوخ کریں',
                'Portrait': 'عمودی',
                'Landscape': 'افقی',
                'A4': 'A4',
                'Letter': 'لیٹر',
                'Legal': 'لیگل',
                'A5': 'A5',
                'Product Report': 'پروڈکٹ رپورٹ',
                'Inventory Report': 'انوینٹری رپورٹ',
                'Total Products': 'کل مصنوعات',
                'Generated': 'تیار کردہ',
                'Report ID': 'رپورٹ آئی ڈی',
                'Generated by': 'تیار کردہ بذریعہ',
                'Shop Code': 'شاپ کوڈ',
                'FILTERS APPLIED': 'فلٹرز لاگو ہیں',
                'Search': 'تلاش کریں',
                'From': 'سے',
                'To': 'تک',
                'Page': 'صفحہ',
                'Stock Status': 'اسٹاک کی حیثیت',
                'Low Stock': 'کم اسٹاک',
                'Out of Stock': 'اسٹاک ختم',
                'In Stock': 'اسٹاک میں ہے',
                'Packing Type': 'پیکنگ کی قسم',
                'Sub Packing': 'ذیلی پیکنگ',
                'Items/Pack': 'آئٹمز/پیک',
                'Cost/Pack': 'لاگت/پیک',
                'Price/Pack': 'قیمت/پیک',
                'Cost/Unit': 'لاگت/یونٹ',
                'Price/Unit': 'قیمت/یونٹ',
                'Stock Value': 'اسٹاک ویلیو',
                'Expiry Date': 'میعاد ختم ہونے کی تاریخ',
                'Low Stock Alert': 'کم اسٹاک الرٹ',
                'Unit of Measure': 'پیمائش کی اکائی',
                'Cost Per Pack': 'فی پیک لاگت',
                'Sell Price Per Unit': 'فی یونٹ فروخت قیمت',
                'Total Quantity': 'کل مقدار',
                'Sub Packing Type': 'ذیلی پیکنگ کی قسم',
                'Items Per Pack': 'فی پیک اشیاء',
                'Cost Per Unit': 'فی یونٹ لاگت',
                'Sell Per Pack': 'فی پیک فروخت قیمت'
            },
            'ar': {
                'Products List': 'قائمة المنتجات',
                'All products details are below': 'جميع تفاصيل المنتجات أدناه',
                'Product Name': 'اسم المنتج',
                'Category': 'الفئة',
                'Company': 'الشركة',
                'Color': 'اللون',
                'Size': 'الحجم',
                'Batch Number': 'رقم الدفعة',
                'Barcode': 'الباركود',
                'Quantity': 'الكمية',
                'BQuantity': 'كمية الصندوق',
                'Cost Price': 'سعر التكلفة',
                'Selling Price': 'سعر البيع',
                'Unit': 'الوحدة',
                'Actions': 'الإجراءات',
                'Added By': 'أضيف بواسطة',
                'Search products...': 'بحث عن منتجات...',
                'Refresh': 'تحديث',
                'Export PDF': 'تصدير PDF',
                'Edit': 'تعديل',
                'Delete': 'حذف',
                'Close': 'إغلاق',
                'Save Changes': 'حفظ التغييرات',
                'Cancel': 'إلغاء',
                'Success': 'نجاح',
                'Error': 'خطأ',
                'Warning': 'تحذير',
                'Showing': 'عرض',
                'of': 'من',
                'Previous': 'السابق',
                'Next': 'التالي',
                'All': 'الكل',
                'Product Details': 'تفاصيل المنتج',
                'Stock Information': 'معلومات المخزون',
                'Packing Information': 'معلومات التغليف',
                'No shop selected': 'لم يتم اختيار متجر',
                'Please select a shop to view products': 'الرجاء اختيار متجر لعرض المنتجات',
                'S.No': 'رقم',
                'Products': 'المنتجات',
                'Shop': 'متجر',
                'View': 'عرض',
                'Update Product': 'تحديث المنتج',
                'Updating...': 'جاري التحديث...',
                'Product updated successfully': 'تم تحديث المنتج بنجاح',
                'Error updating product': 'خطأ في تحديث المنتج',
                'Confirm Delete': 'تأكيد الحذف',
                'Yes, Delete': 'نعم، حذف',
                'No, Cancel': 'لا، إلغاء',
                'Portrait': 'عمودي',
                'Landscape': 'أفقي',
                'A4': 'A4',
                'Letter': 'رسالة',
                'Legal': 'قانوني',
                'A5': 'A5',
                'Product Report': 'تقرير المنتجات',
                'Inventory Report': 'تقرير المخزون',
                'Total Products': 'إجمالي المنتجات',
                'Generated': 'تم الإنشاء',
                'Report ID': 'معرف التقرير',
                'Generated by': 'تم الإنشاء بواسطة',
                'Shop Code': 'رمز المتجر',
                'FILTERS APPLIED': 'المرشحات المطبقة',
                'Search': 'بحث',
                'From': 'من',
                'To': 'إلى',
                'Page': 'صفحة',
                'Stock Status': 'حالة المخزون',
                'Low Stock': 'مخزون منخفض',
                'Out of Stock': 'نفد المخزون',
                'In Stock': 'متوفر',
                'Packing Type': 'نوع التغليف',
                'Sub Packing': 'التغليف الفرعي',
                'Items/Pack': 'القطع/العبوة',
                'Cost/Pack': 'التكلفة/العبوة',
                'Price/Pack': 'السعر/العبوة',
                'Cost/Unit': 'التكلفة/الوحدة',
                'Price/Unit': 'السعر/الوحدة',
                'Stock Value': 'قيمة المخزون',
                'Expiry Date': 'تاريخ الانتهاء',
                'Low Stock Alert': 'تنبيه المخزون المنخفض',
                'Unit of Measure': 'وحدة القياس',
                'Cost Per Pack': 'التكلفة لكل عبوة',
                'Sell Price Per Unit': 'سعر البيع لكل وحدة',
                'Total Quantity': 'الكمية الإجمالية',
                'Sub Packing Type': 'نوع التغليف الفرعي',
                'Items Per Pack': 'القطع لكل عبوة',
                'Cost Per Unit': 'التكلفة لكل وحدة',
                'Sell Per Pack': 'البيع لكل عبوة'
            }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
            return dict[targetLang][text];
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) { }

        try {
            const response = await fetch(
                `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLang}`
            );
            if (response.ok) {
                const data = await response.json();
                return data.responseData.translatedText;
            }
        } catch (e) { }

        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;
        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }
        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();
        return translated;
    };

    const defaultTexts = {
        productList: 'Products List',
        formDetails: 'All products details are below',
        products: 'Products',
        shopName: 'Shop',
        noShopSelected: 'No shop selected. Please select a shop first.',
        switchShop: 'Switch Shop',
        loadingShops: 'Loading shops...',
        noShops: 'No shops available',
        current: 'Current',
        searchPlaceholder: 'Search products...',
        refresh: 'Refresh',
        loadingUserData: 'Loading your product data...',
        selectShop: 'Please select a shop to view products',
        productName: 'Product Name',
        category: 'Category',
        company: 'Company',
        color: 'Color',
        size: 'Size',
        batchNumber: 'Batch Number',
        barcode: 'Barcode',
        quantity: 'Quantity',
        bquantity: 'BQuantity',
        costPrice: 'Cost Price',
        sellingPrice: 'Selling Price',
        unit: 'Unit',
        actions: 'Actions',
        addedBy: 'Added By',
        serialNo: 'S.No',
        showing: 'Showing',
        of: 'of',
        previous: 'Previous',
        next: 'Next',
        all: 'All',
        productNameFilter: 'Product Name',
        categoryFilter: 'Category',
        companyFilter: 'Company Name',
        colorFilter: 'Color',
        sizeFilter: 'Size',
        batchFilter: 'Batch Number',
        barcodeFilter: 'Barcode',
        addedByFilter: 'Added By',
        startDate: 'Start Date',
        endDate: 'End Date',
        exportToPDF: 'Export PDF',
        orientation: 'Orientation',
        portrait: 'Portrait',
        landscape: 'Landscape',
        pageSize: 'Page Size',
        a4: 'A4',
        letter: 'Letter',
        legal: 'Legal',
        a5: 'A5',
        productDetails: 'Product Details',
        stockInfo: 'Stock Information',
        packingInfo: 'Packing Information',
        editProduct: 'Edit Product',
        saveChanges: 'Save Changes',
        cancel: 'Cancel',
        confirmDelete: 'Confirm Delete',
        deleteMessage: 'Are you sure you want to delete this product?',
        deleteWarning: 'This action cannot be undone.',
        yesDelete: 'Yes, Delete',
        noCancel: 'No, Cancel',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        close: 'Close',
        productReport: 'Product Report',
        inventoryReport: 'Inventory Report',
        totalProducts: 'Total Products',
        generated: 'Generated',
        reportId: 'Report ID',
        generatedBy: 'Generated by',
        shopCode: 'Shop Code',
        filtersApplied: 'FILTERS APPLIED',
        search: 'Search',
        from: 'From',
        to: 'To',
        page: 'Page',
        stockStatus: 'Stock Status',
        lowStock: 'Low Stock',
        outOfStock: 'Out of Stock',
        inStock: 'In Stock',
        packingType: 'Packing Type',
        subPackingType: 'Sub Packing Type',
        itemsPerPack: 'Items/Pack',
        costPerPack: 'Cost/Pack',
        sellPerPack: 'Price/Pack',
        costPerUnit: 'Cost/Unit',
        sellPerUnit: 'Price/Unit',
        stockValue: 'Stock Value',
        expiryDate: 'Expiry Date',
        lowStockAlert: 'Low Stock Alert',
        unitOfMeasure: 'Unit of Measure',
        totalQuantity: 'Total Quantity'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') {
            return defaultTexts;
        }

        const translations = {};
        const promises = [];

        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    translateText(defaultTexts[key], lang).then(translated => {
                        translations[key] = translated;
                    })
                );
            }
        });

        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }

        return translations;
    };

    loadFromCache();

    return {
        getTranslations,
        translateText
    };
};

const productListTranslator = createProductListTranslator();

// Toast Notification Component
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };
    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations?.success || 'Success';
            case 'error': return translations?.error || 'Error';
            case 'warning': return translations?.warning || 'Warning';
            default: return '';
        }
    };
    if (!toast.show) return null;
    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon"><FontAwesomeIcon icon={getIconForType(toast.type)} /></div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};

// Shop Selector Modal Component
const ShopSelectorModal = ({ isOpen, onClose, shops, currentShop, onSelectShop, translations, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="ozlistui-modal-overlay" onClick={onClose}>
            <div className="ozlistui-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="ozlistui-modal-header">
                    <h3>{translations.switchShop || 'Switch Shop'}</h3>
                    <button className="ozlistui-close-btn" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozlistui-modal-body">
                    {loading ? (
                        <div className="ozlistui-loading-shops">
                            <div className="ozlistui-loading-spinner-small"></div>
                            <p>{translations.loadingShops || 'Loading shops...'}</p>
                        </div>
                    ) : shops.length === 0 ? (
                        <div className="ozlistui-no-shops">
                            <p>{translations.noShops || 'No shops available'}</p>
                        </div>
                    ) : (
                        <div className="ozlistui-shop-list">
                            {shops.map((shop) => (
                                <div
                                    key={shop.shop_id}
                                    className={`ozlistui-shop-item ${currentShop?.shop_id === shop.shop_id ? 'ozlistui-active' : ''}`}
                                    onClick={() => onSelectShop(shop)}
                                >
                                    <div className="ozlistui-shop-item-icon">
                                        <FontAwesomeIcon icon={faStore} />
                                    </div>
                                    <div className="ozlistui-shop-item-details">
                                        <div className="ozlistui-shop-item-name">{shop.shop_name}</div>
                                        <div className="ozlistui-shop-item-code">{shop.shop_code || `ID: ${shop.shop_id}`}</div>
                                    </div>
                                    {currentShop?.shop_id === shop.shop_id && (
                                        <div className="ozlistui-shop-item-current">
                                            <FontAwesomeIcon icon={faCheckCircle} />
                                            <span>{translations.current || 'Current'}</span>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// Custom Dropdown Component
const CustomDropdown = ({ label, icon, value, onChange, options, placeholder, translations, disabled = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const wrapperRef = useRef(null);

    const selectedOption = options.find(opt => opt.value === value);
    const displayValue = selectedOption?.label || '';

    useEffect(() => {
        setSearchTerm(displayValue);
    }, [displayValue]);

    const filteredOptions = searchTerm.trim() === ''
        ? options
        : options.filter(opt =>
            opt.label.toLowerCase().includes(searchTerm.toLowerCase())
        );

    const handleSelect = (option) => {
        onChange(option.value);
        setSearchTerm(option.label);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="ozlistui-custom-dropdown-wrapper" ref={wrapperRef}>
            <div className="ozlistui-custom-input-wrapper">
                <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setIsOpen(true);
                        if (!options.find(opt => opt.label.toLowerCase() === e.target.value.toLowerCase())) {
                            onChange('');
                        }
                    }}
                    onFocus={() => setIsOpen(true)}
                    placeholder=" "
                    disabled={disabled}
                    autoComplete="off"
                />
                <label>
                    {icon && <FontAwesomeIcon icon={icon} />}
                    {label}
                </label>
                <FontAwesomeIcon icon={faChevronDown} className="ozlistui-custom-dropdown-arrow" />
            </div>

            {isOpen && (
                <div className="ozlistui-custom-dropdown-menu">
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map(opt => (
                            <div
                                key={opt.value}
                                className={`ozlistui-custom-dropdown-option ${value === opt.value ? 'ozlistui-selected' : ''}`}
                                onClick={() => handleSelect(opt)}
                            >
                                {opt.label}
                            </div>
                        ))
                    ) : (
                        <div className="ozlistui-custom-dropdown-empty">
                            No options found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

// Helper function to parse packaging info
const parsePackagingInfo = (product) => {
    if (product.packaging_info) {
        try {
            if (typeof product.packaging_info === 'string') {
                return JSON.parse(product.packaging_info);
            }
            return product.packaging_info;
        } catch (e) {
            return null;
        }
    }
    return null;
};

// Color options for filter
const colorOptions = [
    { value: '', label: 'All Colors' },
    { value: 'red', label: 'Red' },
    { value: 'blue', label: 'Blue' },
    { value: 'green', label: 'Green' },
    { value: 'yellow', label: 'Yellow' },
    { value: 'orange', label: 'Orange' },
    { value: 'purple', label: 'Purple' },
    { value: 'pink', label: 'Pink' },
    { value: 'brown', label: 'Brown' },
    { value: 'black', label: 'Black' },
    { value: 'white', label: 'White' },
    { value: 'gray', label: 'Gray' },
    { value: 'silver', label: 'Silver' },
    { value: 'gold', label: 'Gold' },
    { value: 'beige', label: 'Beige' },
    { value: 'cream', label: 'Cream' },
    { value: 'maroon', label: 'Maroon' },
    { value: 'navy', label: 'Navy Blue' },
    { value: 'teal', label: 'Teal' },
    { value: 'turquoise', label: 'Turquoise' },
    { value: 'lime', label: 'Lime' },
    { value: 'olive', label: 'Olive' },
    { value: 'coral', label: 'Coral' },
    { value: 'salmon', label: 'Salmon' },
    { value: 'lavender', label: 'Lavender' },
    { value: 'violet', label: 'Violet' },
    { value: 'magenta', label: 'Magenta' },
    { value: 'cyan', label: 'Cyan' },
    { value: 'indigo', label: 'Indigo' },
    { value: 'amber', label: 'Amber' },
    { value: 'peach', label: 'Peach' },
    { value: 'mint', label: 'Mint' },
    { value: 'sage', label: 'Sage' },
    { value: 'tan', label: 'Tan' },
    { value: 'ivory', label: 'Ivory' },
    { value: 'charcoal', label: 'Charcoal' },
    { value: 'slate', label: 'Slate' },
    { value: 'champagne', label: 'Champagne' },
    { value: 'rose', label: 'Rose' },
    { value: 'crimson', label: 'Crimson' },
    { value: 'burgundy', label: 'Burgundy' },
    { value: 'plum', label: 'Plum' },
    { value: 'mauve', label: 'Mauve' },
    { value: 'fawn', label: 'Fawn' },
    { value: 'mustard', label: 'Mustard' },
    { value: 'rust', label: 'Rust' },
    { value: 'terracotta', label: 'Terracotta' },
    { value: 'copper', label: 'Copper' },
    { value: 'bronze', label: 'Bronze' },
    { value: 'metallic', label: 'Metallic' },
    { value: 'multi', label: 'Multi-Color' },
    { value: 'transparent', label: 'Transparent' },
    { value: 'other', label: 'Other' }
];

// Size options for filter
const sizeOptions = [
    { value: '', label: 'All Sizes' },
    { value: 's', label: 'S' },
    { value: 'm', label: 'M' },
    { value: 'l', label: 'L' },
    { value: 'xl', label: 'XL' },
    { value: 'xxl', label: 'XXL' },
    { value: 'xxxl', label: 'XXXL' },
    { value: '4xl', label: '4XL' },
    { value: '5xl', label: '5XL' },
    { value: '6xl', label: '6XL' },
    { value: '7xl', label: '7XL' },
    { value: '8xl', label: '8XL' },
    { value: '0', label: '0' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' },
    { value: '8', label: '8' },
    { value: '9', label: '9' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
    { value: '13', label: '13' },
    { value: '14', label: '14' },
    { value: '1_cm', label: '1 cm' },
    { value: '2_cm', label: '2 cm' },
    { value: '3_cm', label: '3 cm' },
    { value: '4_cm', label: '4 cm' },
    { value: '5_cm', label: '5 cm' },
    { value: '6_cm', label: '6 cm' },
    { value: '7_cm', label: '7 cm' },
    { value: '8_cm', label: '8 cm' },
    { value: '9_cm', label: '9 cm' },
    { value: '10_cm', label: '10 cm' },
    { value: '11_cm', label: '11 cm' },
    { value: '12_cm', label: '12 cm' },
    { value: '13_cm', label: '13 cm' },
    { value: '14_cm', label: '14 cm' },
    { value: '15_cm', label: '15 cm' },
    { value: '16_cm', label: '16 cm' },
    { value: '17_cm', label: '17 cm' },
    { value: '18_cm', label: '18 cm' },
    { value: '19_cm', label: '19 cm' },
    { value: '20_cm', label: '20 cm' },
    { value: '22_cm', label: '22 cm' },
    { value: '24_cm', label: '24 cm' },
    { value: '25_cm', label: '25 cm' },
    { value: '26_cm', label: '26 cm' },
    { value: '28_cm', label: '28 cm' },
    { value: '30_cm', label: '30 cm' },
    { value: '32_cm', label: '32 cm' },
    { value: '35_cm', label: '35 cm' },
    { value: '40_cm', label: '40 cm' },
    { value: '45_cm', label: '45 cm' },
    { value: '50_cm', label: '50 cm' },
    { value: '55_cm', label: '55 cm' },
    { value: '60_cm', label: '60 cm' },
    { value: '65_cm', label: '65 cm' },
    { value: '70_cm', label: '70 cm' },
    { value: '75_cm', label: '75 cm' },
    { value: '80_cm', label: '80 cm' },
    { value: '85_cm', label: '85 cm' },
    { value: '90_cm', label: '90 cm' },
    { value: '95_cm', label: '95 cm' },
    { value: '100_cm', label: '100 cm' },
    { value: '1_ft', label: '1 ft' },
    { value: '2_ft', label: '2 ft' },
    { value: '3_ft', label: '3 ft' },
    { value: '4_ft', label: '4 ft' },
    { value: '5_ft', label: '5 ft' },
    { value: '6_ft', label: '6 ft' },
    { value: '7_ft', label: '7 ft' },
    { value: '8_ft', label: '8 ft' },
    { value: '9_ft', label: '9 ft' },
    { value: '10_ft', label: '10 ft' },
    { value: '11_ft', label: '11 ft' },
    { value: '12_ft', label: '12 ft' },
    { value: '13_ft', label: '13 ft' },
    { value: '14_ft', label: '14 ft' },
    { value: '15_ft', label: '15 ft' },
    { value: '16_ft', label: '16 ft' },
    { value: '17_ft', label: '17 ft' },
    { value: '18_ft', label: '18 ft' },
    { value: '19_ft', label: '19 ft' },
    { value: '20_ft', label: '20 ft' },
    { value: '0.5_m', label: '0.5 m' },
    { value: '1_m', label: '1 m' },
    { value: '1.5_m', label: '1.5 m' },
    { value: '2_m', label: '2 m' },
    { value: '2.5_m', label: '2.5 m' },
    { value: '3_m', label: '3 m' },
    { value: '4_m', label: '4 m' },
    { value: '5_m', label: '5 m' },
    { value: '6_m', label: '6 m' },
    { value: '7_m', label: '7 m' },
    { value: '8_m', label: '8 m' },
    { value: '9_m', label: '9 m' },
    { value: '10_m', label: '10 m' },
    { value: '12_m', label: '12 m' },
    { value: '15_m', label: '15 m' },
    { value: '20_m', label: '20 m' },
    { value: '25_m', label: '25 m' },
    { value: '30_m', label: '30 m' },
    { value: '40_m', label: '40 m' },
    { value: '50_m', label: '50 m' },
    { value: '60_m', label: '60 m' },
    { value: '70_m', label: '70 m' },
    { value: '80_m', label: '80 m' },
    { value: '90_m', label: '90 m' },
    { value: '100_m', label: '100 m' },
    { value: 'one_size', label: 'One Size' },
    { value: 'free_size', label: 'Free Size' },
    { value: 'adjustable', label: 'Adjustable' },
    { value: 'custom', label: 'Custom' },
    { value: 'other', label: 'Other' }
];

// Main Component
const SolarProductsList = () => {
    const { user, currentShop, switchShop, getShopsForSwitch } = useAuth();
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);
    const [editLoading, setEditLoading] = useState(false);
    const [showFilters, setShowFilters] = useState(false);

    // PDF Options State
    const [pdfOrientation, setPdfOrientation] = useState('landscape');
    const [pdfPageSize, setPdfPageSize] = useState('a4');
    const [pdfPageRange, setPdfPageRange] = useState('all');
    const [pdfStartPage, setPdfStartPage] = useState(1);
    const [pdfEndPage, setPdfEndPage] = useState(1);

    // Shop selector state
    const [showShopSelector, setShowShopSelector] = useState(false);
    const [availableShops, setAvailableShops] = useState([]);
    const [loadingShops, setLoadingShops] = useState(false);

    // Modal drag and resize state
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
    const [modalSize, setModalSize] = useState({ width: 650, height: 'auto' });
    const [isDragging, setIsDragging] = useState(false);
    const [isResizing, setIsResizing] = useState(false);
    const [currentWidthMode, setCurrentWidthMode] = useState('wide');
    const [isModalInitialized, setIsModalInitialized] = useState(false);

    const dragStart = useRef({ x: 0, y: 0 });
    const modalRef = useRef(null);
    const resizeType = useRef(null);
    const resizeStart = useRef({ x: 0, y: 0, width: 0, height: 0, left: 0, top: 0 });

    const widthModes = {
        narrow: { width: 400, label: 'Narrow', icon: faMinus },
        medium: { width: 650, label: 'Medium', icon: faArrowsAlt },
        wide: { width: 950, label: 'Wide', icon: faPlus },
        full: { width: '95vw', label: 'Full Width', icon: faExpand },
        fullscreen: { width: '98vw', label: 'Full Screen', icon: faCompress }
    };

    // Theme, Dark Mode, Language State
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem('ourzest_language') || 'en';
    });
    const [currentTheme, setCurrentTheme] = useState(() => {
        return localStorage.getItem('ourzest_theme') || '#6366f1';
    });
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('ourzest_darkMode') === 'true';
    });
    const [translations, setTranslations] = useState({});

    // Toast state
    const [toast, setToast] = useState({
        show: false,
        type: '',
        message: '',
        progress: 100,
        timeLeft: 3
    });

    const toastTimerRef = useRef(null);
    const isMountedRef = useRef(true);

    // Edit form state
    const [editFormData, setEditFormData] = useState({
        product_name: '',
        batch_no: '',
        barcode: '',
        company: '',
        cost_price_per_pack: '',
        sell_price_per_unit: '',
        total_quantity: '',
        quantity_alert: '1',
        expiry_date: '',
        cost_per_unit: '',
        sell_per_pack: '',
        packing_type: 'packet',
        sub_packing_type: 'piece',
        items_per_pack: '1',
        unit_of_measure: 'piece',
        category: '',
        color: '',
        size: ''
    });
    const [editFormErrors, setEditFormErrors] = useState({});

    // Business info state
    const [businessInfo, setBusinessInfo] = useState({
        businessname: '',
        bussinesslogo: '',
        businessaddress: '',
        fullname: '',
        email: ''
    });

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);

    // Filter states
    const [filterBy, setFilterBy] = useState('');
    const [productNameFilter, setProductNameFilter] = useState('');
    const [categoryFilter, setCategoryFilter] = useState('');
    const [companyFilter, setCompanyFilter] = useState('');
    const [colorFilter, setColorFilter] = useState('');
    const [sizeFilter, setSizeFilter] = useState('');
    const [batchFilter, setBatchFilter] = useState('');
    const [barcodeFilter, setBarcodeFilter] = useState('');
    const [addedByFilter, setAddedByFilter] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [stockStatusFilter, setStockStatusFilter] = useState('');

    const escapeHtml = (text) => {
        if (!text) return '';
        return String(text).replace(/[&<>]/g, function (m) {
            if (m === '&') return '&amp;';
            if (m === '<') return '&lt;';
            if (m === '>') return '&gt;';
            return m;
        });
    };

    const filterByOptions = useMemo(() => [
        { value: 'all', label: translations.all || 'All' },
        { value: 'productName', label: translations.productNameFilter || 'Product Name' },
        { value: 'category', label: translations.categoryFilter || 'Category' },
        { value: 'company', label: translations.companyFilter || 'Company Name' },
        { value: 'color', label: translations.colorFilter || 'Color' },
        { value: 'size', label: translations.sizeFilter || 'Size' },
        { value: 'batch', label: translations.batchFilter || 'Batch Number' },
        { value: 'barcode', label: translations.barcodeFilter || 'Barcode' },
        { value: 'added_by', label: translations.addedByFilter || 'Added By' }
    ], [translations]);

    const stockStatusOptions = useMemo(() => [
        { value: '', label: translations.all || 'All' },
        { value: 'inStock', label: translations.inStock || 'In Stock' },
        { value: 'lowStock', label: translations.lowStock || 'Low Stock' },
        { value: 'outOfStock', label: translations.outOfStock || 'Out of Stock' }
    ], [translations]);

    const pdfOrientationOptions = useMemo(() => [
        { value: 'portrait', label: translations.portrait || 'Portrait' },
        { value: 'landscape', label: translations.landscape || 'Landscape' }
    ], [translations]);

    const pdfPageSizeOptions = useMemo(() => [
        { value: 'a4', label: translations.a4 || 'A4' },
        { value: 'letter', label: translations.letter || 'Letter' },
        { value: 'legal', label: translations.legal || 'Legal' },
        { value: 'a5', label: translations.a5 || 'A5' }
    ], [translations]);

    const showToast = useCallback((type, message) => {
        if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        setToast({ show: true, type, message, progress: 100, timeLeft: 3 });
        let timeLeft = 3;
        const timer = setInterval(() => {
            timeLeft -= 0.1;
            const progress = (timeLeft / 3) * 100;
            setToast(prev => ({ ...prev, progress, timeLeft: parseFloat(timeLeft.toFixed(1)) }));
            if (timeLeft <= 0) {
                clearInterval(timer);
                setToast(prev => ({ ...prev, show: false }));
            }
        }, 100);
        toastTimerRef.current = timer;
    }, []);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
            if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        };
    }, []);

    // ============================================
    // THEME SYNC
    // ============================================
    useEffect(() => {
        const applyTheme = (color) => {
            if (!color || !/^#[0-9A-F]{6}$/i.test(color)) color = '#6366f1';
            document.documentElement.style.setProperty('--ozlistui-primary', color);
            document.documentElement.style.setProperty('--ozlistui-primary-dark', color);
            document.documentElement.style.setProperty('--ozlistui-primary-light', color);
            setCurrentTheme(color);
        };

        applyTheme(currentTheme);

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') {
                const newTheme = e.newValue || '#6366f1';
                applyTheme(newTheme);
            }
        };

        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);

        const interval = setInterval(() => {
            const storedTheme = localStorage.getItem('ourzest_theme');
            if (storedTheme && storedTheme !== currentTheme) {
                applyTheme(storedTheme);
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
            clearInterval(interval);
        };
    }, [currentTheme]);

    // ============================================
    // DARK MODE SYNC
    // ============================================
    useEffect(() => {
        const syncDarkMode = () => {
            const isDark = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDark);

            const container = document.querySelector('.ozlistui-container');
            if (container) {
                if (isDark) {
                    container.classList.add('ozlistui-dark');
                } else {
                    container.classList.remove('ozlistui-dark');
                }
            }

            if (isDark) {
                document.body.classList.add('ozlistui-dark');
                document.documentElement.classList.add('ozlistui-dark');
            } else {
                document.body.classList.remove('ozlistui-dark');
                document.documentElement.classList.remove('ozlistui-dark');
            }
        };

        syncDarkMode();

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') {
                syncDarkMode();
            }
        };

        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);
                const container = document.querySelector('.ozlistui-container');
                if (container) {
                    if (isDark) {
                        container.classList.add('ozlistui-dark');
                    } else {
                        container.classList.remove('ozlistui-dark');
                    }
                }
                if (isDark) {
                    document.body.classList.add('ozlistui-dark');
                    document.documentElement.classList.add('ozlistui-dark');
                } else {
                    document.body.classList.remove('ozlistui-dark');
                    document.documentElement.classList.remove('ozlistui-dark');
                }
            } else {
                syncDarkMode();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);

        const interval = setInterval(() => {
            const storedDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            if (storedDarkMode !== darkMode) {
                syncDarkMode();
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
            clearInterval(interval);
        };
    }, [darkMode]);

    // ============================================
    // LANGUAGE SYNC
    // ============================================
    useEffect(() => {
        const loadTranslations = async (lang) => {
            const trans = await productListTranslator.getTranslations(lang);
            setTranslations(trans);
        };

        const handleLanguageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };

        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };

        loadTranslations(currentLanguage);

        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);

        const interval = setInterval(() => {
            const storedLang = localStorage.getItem('ourzest_language') || 'en';
            if (storedLang !== currentLanguage) {
                setCurrentLanguage(storedLang);
                loadTranslations(storedLang);
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
            clearInterval(interval);
        };
    }, [currentLanguage]);

    // ============================================
    // RTL DIRECTION SYNC
    // ============================================
    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.ozlistui-container');

        if (container) {
            if (isRTL) {
                container.classList.add('ozlistui-rtl');
                container.classList.remove('ozlistui-ltr');
            } else {
                container.classList.add('ozlistui-ltr');
                container.classList.remove('ozlistui-rtl');
            }
        }

        if (isRTL) {
            document.documentElement.dir = 'rtl';
            document.body.dir = 'rtl';
        } else {
            document.documentElement.dir = 'ltr';
            document.body.dir = 'ltr';
        }
    }, [currentLanguage]);

    // Center modal function
    const centerModal = useCallback(() => {
        if (!modalRef.current) return;
        const rect = modalRef.current.getBoundingClientRect();
        const left = (window.innerWidth - rect.width) / 2;
        const top = (window.innerHeight - rect.height) / 2;
        modalRef.current.style.left = `${Math.max(0, left)}px`;
        modalRef.current.style.top = `${Math.max(0, top)}px`;
        modalRef.current.style.transform = 'none';
        setModalPosition({ x: Math.max(0, left), y: Math.max(0, top) });
    }, []);

    const setWidthMode = useCallback((mode) => {
        if (!modalRef.current) return;
        setCurrentWidthMode(mode);
        const widthValue = widthModes[mode].width;
        if (mode === 'fullscreen') {
            modalRef.current.style.width = '98vw';
            modalRef.current.style.height = '90vh';
        } else {
            modalRef.current.style.width = typeof widthValue === 'number' ? `${widthValue}px` : widthValue;
            modalRef.current.style.height = 'auto';
        }
        setModalSize({ width: modalRef.current.offsetWidth, height: modalRef.current.offsetHeight });
        setTimeout(() => centerModal(), 10);
    }, [widthModes, centerModal]);

    const startDrag = useCallback((e) => {
        if (!modalRef.current) return;
        if (e.target.closest('button, input, select, textarea, a, .ozlistui-width-btn, .ozlistui-close-btn')) return;
        e.preventDefault();
        setIsDragging(true);
        const rect = modalRef.current.getBoundingClientRect();
        dragStart.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
        modalRef.current.style.transition = 'none';
    }, []);

    const startResize = useCallback((e, type) => {
        e.preventDefault();
        e.stopPropagation();
        if (!modalRef.current) return;
        setIsResizing(true);
        resizeType.current = type;
        const rect = modalRef.current.getBoundingClientRect();
        resizeStart.current = {
            x: e.clientX, y: e.clientY,
            width: rect.width, height: rect.height,
            left: rect.left, top: rect.top,
            minWidth: 350, minHeight: 400,
            maxWidth: window.innerWidth - 40, maxHeight: window.innerHeight - 40
        };
        modalRef.current.style.transition = 'none';
    }, []);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (isDragging && modalRef.current) {
                let newLeft = e.clientX - dragStart.current.x;
                let newTop = e.clientY - dragStart.current.y;
                const rect = modalRef.current.getBoundingClientRect();
                newLeft = Math.max(0, Math.min(newLeft, window.innerWidth - rect.width));
                newTop = Math.max(0, Math.min(newTop, window.innerHeight - rect.height));
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                modalRef.current.style.transform = 'none';
                setModalPosition({ x: newLeft, y: newTop });
            }

            if (isResizing && modalRef.current && resizeType.current) {
                let newWidth = resizeStart.current.width;
                let newHeight = resizeStart.current.height;
                let newLeft = resizeStart.current.left;
                let newTop = resizeStart.current.top;
                const deltaX = e.clientX - resizeStart.current.x;
                const deltaY = e.clientY - resizeStart.current.y;

                switch (resizeType.current) {
                    case 'e': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); break;
                    case 'w': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); break;
                    case 's': newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); break;
                    case 'n': newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'ne': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'nw': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'se': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); break;
                    case 'sw': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); break;
                }
                modalRef.current.style.width = `${newWidth}px`;
                modalRef.current.style.height = `${newHeight}px`;
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                setModalSize({ width: newWidth, height: newHeight });
                setModalPosition({ x: newLeft, y: newTop });
            }
        };

        const handleMouseUp = () => {
            if (isDragging || isResizing) {
                setIsDragging(false);
                setIsResizing(false);
                resizeType.current = null;
                if (modalRef.current) modalRef.current.style.transition = '';
            }
        };

        if (isDragging || isResizing) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, isResizing]);

    useEffect(() => {
        if (showEditModal && modalRef.current && !isModalInitialized) {
            setTimeout(() => { centerModal(); setWidthMode('wide'); setIsModalInitialized(true); }, 50);
        }
        if (!showEditModal) setIsModalInitialized(false);
    }, [showEditModal, centerModal, setWidthMode, isModalInitialized]);

    useEffect(() => {
        const handleWindowResize = () => {
            if (!modalRef.current || !showEditModal) return;
            const rect = modalRef.current.getBoundingClientRect();
            let newLeft = Math.min(rect.left, window.innerWidth - rect.width);
            let newTop = Math.min(rect.top, window.innerHeight - rect.height);
            newLeft = Math.max(0, newLeft);
            newTop = Math.max(0, newTop);
            if (newLeft !== rect.left || newTop !== rect.top) {
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                setModalPosition({ x: newLeft, y: newTop });
            }
        };
        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, [showEditModal]);

    // Fetch products
    const fetchProducts = useCallback(async () => {
        if (!user || !user.username) {
            if (isMountedRef.current) {
                showToast('error', 'User information not available');
                setLoading(false);
            }
            return;
        }
        if (!currentShop) {
            if (isMountedRef.current) {
                showToast('error', translations.noShopSelected || 'Please select a shop first');
                setLoading(false);
            }
            return;
        }
        if (isMountedRef.current) setLoading(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/cosmetics_module/cosmetics_products.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_records',
                    username: user.username,
                    shop_id: currentShop.shop_id
                })
            });
            const data = await response.json();
            if (isMountedRef.current) {
                if (data.status === 'success') {
                    setProducts(data.data || []);
                    resetFilters();
                } else {
                    showToast('error', data.message || translations.networkError || 'Network error occurred');
                }
            }
        } catch (error) {
            console.error('Error fetching products:', error);
            if (isMountedRef.current) showToast('error', translations.networkError || 'Network error occurred');
        } finally {
            if (isMountedRef.current) setLoading(false);
        }
    }, [user, currentShop, translations, showToast]);

    const fetchAvailableShops = useCallback(async () => {
        if (!user) return;
        setLoadingShops(true);
        try {
            const shopsData = await getShopsForSwitch();
            if (isMountedRef.current) setAvailableShops(shopsData.shops || []);
        } catch (error) {
            console.error('Error loading shops:', error);
            if (isMountedRef.current) setAvailableShops([]);
        } finally {
            if (isMountedRef.current) setLoadingShops(false);
        }
    }, [user, getShopsForSwitch]);

    const fetchBusinessInfo = useCallback(async () => {
        if (!user || !user.username) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/get_business_info.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_business_info', username: user.username })
            });
            const data = await response.json();
            if (isMountedRef.current) {
                if (data.status === 'success') {
                    setBusinessInfo({
                        businessname: data.businessname || '',
                        bussinesslogo: data.bussinesslogo || '',
                        businessaddress: data.businessaddress || '',
                        fullname: data.fullname || '',
                        email: data.email || ''
                    });
                } else {
                    setBusinessInfo({
                        businessname: user.business_name || '',
                        bussinesslogo: '',
                        businessaddress: '',
                        fullname: user.fullname || '',
                        email: user.email || ''
                    });
                }
            }
        } catch (error) {
            console.error('Error fetching business info:', error);
            if (isMountedRef.current) {
                setBusinessInfo({
                    businessname: user.business_name || '',
                    bussinesslogo: '',
                    businessaddress: '',
                    fullname: user.fullname || '',
                    email: user.email || ''
                });
            }
        }
    }, [user]);

    useEffect(() => {
        if (user && user.username && currentShop) {
            fetchProducts();
            fetchBusinessInfo();
            fetchAvailableShops();
        } else if (user && user.username && !currentShop) {
            setLoading(false);
        } else if (!user) {
            setLoading(false);
        }
    }, [user, currentShop?.shop_id]);

    const handleSwitchShop = useCallback(async (shop) => {
        try {
            const success = await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
            if (success) {
                showToast('success', 'Shop switched successfully');
                setCurrentPage(1);
                resetFilters();
                setShowShopSelector(false);
            } else {
                showToast('error', 'Failed to switch shop');
            }
        } catch (error) {
            console.error('Error switching shop:', error);
            showToast('error', 'Failed to switch shop');
        }
    }, [switchShop, showToast]);

    const applyFilters = useCallback(() => {
        let filtered = [...products];

        // Search term filter
        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(product =>
                product.product_name?.toLowerCase().includes(term) ||
                product.batch_no?.toLowerCase().includes(term) ||
                product.barcode?.toLowerCase().includes(term) ||
                product.company?.toLowerCase().includes(term) ||
                product.category?.toLowerCase().includes(term) ||
                product.color?.toLowerCase().includes(term) ||
                product.size?.toLowerCase().includes(term) ||
                product.added_by_username?.toLowerCase().includes(term) ||
                product.username?.toLowerCase().includes(term)
            );
        }

        // Stock status filter
        if (stockStatusFilter) {
            filtered = filtered.filter(product => {
                const quantity = parseFloat(product.quantity) || 0;
                const alert = parseFloat(product.quantity_alert) || 0;
                if (stockStatusFilter === 'inStock') return quantity > alert;
                if (stockStatusFilter === 'lowStock') return quantity <= alert && quantity > 0;
                if (stockStatusFilter === 'outOfStock') return quantity <= 0;
                return true;
            });
        }

        // Specific filters
        if (filterBy === 'productName' && productNameFilter.trim()) {
            const term = productNameFilter.toLowerCase();
            filtered = filtered.filter(product => product.product_name?.toLowerCase().includes(term));
        }
        if (filterBy === 'category' && categoryFilter.trim()) {
            filtered = filtered.filter(product => product.category?.toLowerCase() === categoryFilter.toLowerCase());
        }
        if (filterBy === 'company' && companyFilter.trim()) {
            const term = companyFilter.toLowerCase();
            filtered = filtered.filter(product => product.company?.toLowerCase().includes(term));
        }
        if (filterBy === 'color' && colorFilter.trim()) {
            filtered = filtered.filter(product => product.color?.toLowerCase() === colorFilter.toLowerCase());
        }
        if (filterBy === 'size' && sizeFilter.trim()) {
            filtered = filtered.filter(product => product.size?.toLowerCase() === sizeFilter.toLowerCase());
        }
        if (filterBy === 'batch' && batchFilter.trim()) {
            const term = batchFilter.toLowerCase();
            filtered = filtered.filter(product => product.batch_no?.toLowerCase().includes(term));
        }
        if (filterBy === 'barcode' && barcodeFilter.trim()) {
            const term = barcodeFilter.toLowerCase();
            filtered = filtered.filter(product => product.barcode?.toLowerCase().includes(term));
        }
        if (filterBy === 'added_by' && addedByFilter.trim()) {
            const term = addedByFilter.toLowerCase();
            filtered = filtered.filter(product =>
                (product.added_by_username?.toLowerCase().includes(term)) ||
                (product.username?.toLowerCase().includes(term))
            );
        }

        // Date range filter
        if (startDate) {
            const start = new Date(startDate);
            filtered = filtered.filter(product => {
                if (!product.date) return false;
                const productDate = new Date(product.date);
                return productDate >= start;
            });
        }
        if (endDate) {
            const end = new Date(endDate);
            filtered = filtered.filter(product => {
                if (!product.date) return false;
                const productDate = new Date(product.date);
                end.setHours(23, 59, 59, 999);
                return productDate <= end;
            });
        }

        setFilteredProducts(filtered);
        setCurrentPage(1);
    }, [products, searchTerm, stockStatusFilter, filterBy, productNameFilter, categoryFilter, companyFilter, colorFilter, sizeFilter, batchFilter, barcodeFilter, addedByFilter, startDate, endDate]);

    useEffect(() => { applyFilters(); }, [applyFilters]);

    const resetFilters = useCallback(() => {
        setFilterBy('');
        setProductNameFilter('');
        setCategoryFilter('');
        setCompanyFilter('');
        setColorFilter('');
        setSizeFilter('');
        setBatchFilter('');
        setBarcodeFilter('');
        setAddedByFilter('');
        setStartDate('');
        setEndDate('');
        setStockStatusFilter('');
        setSearchTerm('');
    }, []);

    const handleSearch = useCallback(() => { applyFilters(); }, [applyFilters]);

    const formatDate = useCallback((dateString) => {
        if (!dateString) return '-';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        } catch { return dateString; }
    }, []);

    const formatDateGlobal = (dateString) => {
        if (!dateString) return '-';
        try {
            const date = new Date(dateString);
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        } catch { return dateString; }
    };

    const currentDateGlobal = () => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    };

    const getTodayDate = useCallback(() => new Date().toISOString().split('T')[0], []);

    // Get rows per page - Landscape: 20 rows, Portrait: 15 rows
    const getRowsPerPage = useCallback(() => {
        if (pdfOrientation === 'landscape') {
            return 18;
        }
        return 12;
    }, [pdfOrientation]);

    const pagination = useMemo(() => {
        const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentProducts = filteredProducts.slice(startIndex, endIndex);
        return { totalPages, startIndex, endIndex, currentProducts };
    }, [filteredProducts, currentPage, itemsPerPage]);

    // ============================================
    // FIXED: Calculate stock value using multiple fallback options
    // ============================================
    const getStockValueForProduct = useCallback((product) => {
        // Try multiple possible field names for cost per unit
        const costPerUnit = parseFloat(
            product.cost_per_unit ||
            product.costPerUnit ||
            product.unit_cost ||
            product.cost_per_pack / (product.items_per_pack || 1) ||
            0
        );
        const quantity = parseFloat(product.quantity || 0);
        return costPerUnit * quantity;
    }, []);

    // Calculate total stock value
    const totalStockValue = filteredProducts
        .filter(product => {
            const quantity = parseFloat(product.quantity || 0);
            return quantity > 0;
        })
        .reduce((sum, product) => {
            return sum + getStockValueForProduct(product);
        }, 0);

    // PDF EXPORT FUNCTION
    const exportToPDF = useCallback(async () => {
        if (!filteredProducts || filteredProducts.length === 0) {
            showToast('warning', translations.noDataToExport || 'No data to export');
            return;
        }
        setPdfLoading(true);
        try {
            const currentLang = currentLanguage;
            const isRTL = currentLang === 'ur' || currentLang === 'ar';

            const pdfTextColor = '#1f2937';
            const pdfSubTextColor = '#6b7280';
            const pdfBorderColor = '#e5e7eb';
            const pdfHeaderBgColor = '#f9fafb';
            const pdfRowEvenBg = '#ffffff';
            const pdfRowOddBg = '#f9fafb';
            const pdfThemeColor = currentTheme;

            const pageSizeMap = { 'a4': 'a4', 'letter': 'letter', 'legal': 'legal', 'a5': 'a5' };
            const pageFormat = pageSizeMap[pdfPageSize] || 'a4';
            const pdf = new jsPDF({ orientation: pdfOrientation, unit: 'mm', format: pageFormat, compress: true });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const rowsPerPage = getRowsPerPage();

            let productsToExport = [...filteredProducts];

            if (pdfPageRange === 'range') {
                const totalPagesForRange = Math.ceil(productsToExport.length / rowsPerPage);
                const start = Math.max(1, pdfStartPage);
                const end = Math.min(totalPagesForRange, pdfEndPage);
                const startIdx = (start - 1) * rowsPerPage;
                const endIdx = Math.min(end * rowsPerPage, productsToExport.length);
                productsToExport = productsToExport.slice(startIdx, endIdx);
            }

            const totalPages = Math.ceil(productsToExport.length / rowsPerPage);

            const getPDFTranslation = (key, fallback = '') => {
                return translations[key] || fallback;
            };

            const renderPage = async (pageProducts, pageNum, startRowIndex) => {
                return new Promise((resolve, reject) => {
                    try {
                        const container = document.createElement('div');
                        container.style.width = '1200px';
                        container.style.padding = '12px 15px';
                        container.style.backgroundColor = '#ffffff';
                        container.style.color = pdfTextColor;
                        container.style.position = 'absolute';
                        container.style.left = '-9999px';
                        container.style.top = '0';
                        container.style.fontFamily = "'Segoe UI', 'Helvetica Neue', Arial, sans-serif";
                        container.style.direction = isRTL ? 'rtl' : 'ltr';

                        const productReportLabel = getPDFTranslation('productReport', 'Product Report');
                        const inventoryReportLabel = getPDFTranslation('inventoryReport', 'Inventory Report');
                        const totalProductsLabel = getPDFTranslation('totalProducts', 'Total Products');
                        const generatedLabel = getPDFTranslation('generated', 'Generated');
                        const reportIdLabel = getPDFTranslation('reportId', 'Report ID');
                        const generatedByLabel = getPDFTranslation('generatedBy', 'Generated by');
                        const shopCodeLabel = getPDFTranslation('shopCode', 'Shop Code');
                        const filtersAppliedLabel = getPDFTranslation('filtersApplied', 'FILTERS APPLIED');
                        const searchLabel = getPDFTranslation('search', 'Search');
                        const fromLabel = getPDFTranslation('from', 'From');
                        const toLabel = getPDFTranslation('to', 'To');
                        const pageLabel = getPDFTranslation('page', 'Page');
                        const ofLabel = getPDFTranslation('of', 'of');
                        const productNameLabel = getPDFTranslation('productName', 'Product Name');
                        const batchLabel = getPDFTranslation('batchNumber', 'Batch Number');
                        const barcodeLabel = getPDFTranslation('barcode', 'Barcode');
                        const companyLabel = getPDFTranslation('company', 'Company');
                        const costPerUnitLabel = getPDFTranslation('costPerUnit', 'Cost/Unit');
                        const sellPerUnitLabel = getPDFTranslation('sellPerUnit', 'Price/Unit');
                        const totalQuantityLabel = getPDFTranslation('totalQuantity', 'Quantity');
                        const sellPerPackLabel = getPDFTranslation('sellPerPack', 'Price/Pack');
                        const expiryLabel = getPDFTranslation('expiryDate', 'Expiry');
                        const lowStockAlertLabel = getPDFTranslation('lowStockAlert', 'Alert');
                        const stockStatusLabel = getPDFTranslation('stockStatus', 'Status');
                        const addedByLabel = getPDFTranslation('addedBy', 'Added By');
                        const stockValueLabel = getPDFTranslation('stockValue', 'Stock Value');

                        const headerHTML = `
                            <div style="margin-bottom: 12px; text-align: center;">
                                <div style="font-size: 8px; letter-spacing: 3px; color: ${pdfSubTextColor}; margin-bottom: 4px; text-transform: uppercase; font-weight: 500;">${productReportLabel}</div>
                                <h1 style="color: ${pdfTextColor}; font-size: 20px; margin: 0 0 4px 0; font-weight: 600;">
                                    ${escapeHtml(currentShop?.shop_name) || escapeHtml(inventoryReportLabel)}
                                </h1>
                                <div style="width: 40px; height: 2px; background: ${pdfThemeColor}; margin: 6px auto;"></div>
                                ${businessInfo.businessname ? `<div style="color: ${pdfSubTextColor}; font-size: 10px; margin-top: 4px;">${escapeHtml(businessInfo.businessname)}</div>` : ''}
                                <div style="color: ${pdfSubTextColor}; font-size: 7px; margin-top: 4px;">
                                    ${totalProductsLabel}: ${productsToExport.length} | ${generatedLabel}: ${new Date().toLocaleString(currentLang)}
                                </div>
                            </div>
                            <div style="display: flex; justify-content: space-between; margin: 8px 0 10px 0; padding: 5px 0; border-top: 1px solid ${pdfBorderColor}; border-bottom: 1px solid ${pdfBorderColor}; ${isRTL ? 'flex-direction: row-reverse;' : ''}">
                                <div style="font-size: 6.5px; color: ${pdfSubTextColor};"><strong>${reportIdLabel}:</strong> #${currentDateGlobal().replace(/-/g, '')}-${String(pageNum).padStart(3, '0')}</div>
                                <div style="font-size: 6.5px; color: ${pdfSubTextColor};"><strong>${generatedByLabel}:</strong> ${escapeHtml(user?.fullname || user?.username || 'System')}</div>
                                <div style="font-size: 6.5px; color: ${pdfSubTextColor};"><strong>${shopCodeLabel}:</strong> ${escapeHtml(currentShop?.shop_code || 'N/A')}</div>
                            </div>
                        `;

                        const hasFilters = searchTerm || categoryFilter || companyFilter || colorFilter || sizeFilter || startDate || endDate;
                        const filterHTML = hasFilters ? `
                            <div style="margin: 6px 0; padding: 4px 10px; background: #f7f7f7; border-${isRTL ? 'right' : 'left'}: 3px solid ${pdfThemeColor}; font-size: 6.5px; color: ${pdfSubTextColor};">
                                <span style="font-weight: 600;">${filtersAppliedLabel}:</span> 
                                ${searchTerm ? `${searchLabel}: "${escapeHtml(searchTerm)}"` : ''}
                                ${categoryFilter ? ` | ${getPDFTranslation('category', 'Category')}: ${escapeHtml(categoryFilter)}` : ''}
                                ${companyFilter ? ` | ${companyLabel}: ${escapeHtml(companyFilter)}` : ''}
                                ${colorFilter ? ` | ${getPDFTranslation('color', 'Color')}: ${escapeHtml(colorFilter)}` : ''}
                                ${sizeFilter ? ` | ${getPDFTranslation('size', 'Size')}: ${escapeHtml(sizeFilter)}` : ''}
                                ${startDate ? ` | ${fromLabel}: ${startDate}` : ''}
                                ${endDate ? ` | ${toLabel}: ${endDate}` : ''}
                            </div>
                        ` : '';

                        let tableHTML = `
                            <table style="width: 100%; border-collapse: collapse; font-size: 5.5px; margin-top: 4px;">
                                <thead>
                                    <tr>
                                        <th style="padding: 3px 3px; background: ${pdfHeaderBgColor}; color: ${pdfTextColor}; font-weight: 600; text-align: center; border: 0.5px solid ${pdfBorderColor};"><span style="font-size: 5px;">${getPDFTranslation('serialNo', 'S.No')}</span></th>
                                        <th style="padding: 3px 3px; background: ${pdfHeaderBgColor}; color: ${pdfTextColor}; font-weight: 600; text-align: ${isRTL ? 'right' : 'left'}; border: 0.5px solid ${pdfBorderColor};"><span style="font-size: 5px;">${productNameLabel}</span></th>
                                        <th style="padding: 3px 3px; background: ${pdfHeaderBgColor}; color: ${pdfTextColor}; font-weight: 600; text-align: center; border: 0.5px solid ${pdfBorderColor};"><span style="font-size: 5px;">${batchLabel}</span></th>
                                        <th style="padding: 3px 3px; background: ${pdfHeaderBgColor}; color: ${pdfTextColor}; font-weight: 600; text-align: center; border: 0.5px solid ${pdfBorderColor};"><span style="font-size: 5px;">${barcodeLabel}</span></th>
                                        <th style="padding: 3px 3px; background: ${pdfHeaderBgColor}; color: ${pdfTextColor}; font-weight: 600; text-align: center; border: 0.5px solid ${pdfBorderColor};"><span style="font-size: 5px;">${companyLabel}</span></th>
                                        <th style="padding: 3px 3px; background: ${pdfHeaderBgColor}; color: ${pdfTextColor}; font-weight: 600; text-align: center; border: 0.5px solid ${pdfBorderColor};"><span style="font-size: 5px;">${costPerUnitLabel}</span></th>
                                        <th style="padding: 3px 3px; background: ${pdfHeaderBgColor}; color: ${pdfTextColor}; font-weight: 600; text-align: center; border: 0.5px solid ${pdfBorderColor};"><span style="font-size: 5px;">${sellPerUnitLabel}</span></th>
                                        <th style="padding: 3px 3px; background: ${pdfHeaderBgColor}; color: ${pdfTextColor}; font-weight: 600; text-align: center; border: 0.5px solid ${pdfBorderColor};"><span style="font-size: 5px;">${sellPerPackLabel}</span></th>
                                        <th style="padding: 3px 3px; background: ${pdfHeaderBgColor}; color: ${pdfTextColor}; font-weight: 600; text-align: center; border: 0.5px solid ${pdfBorderColor};"><span style="font-size: 5px;">${totalQuantityLabel}</span></th>
                                        <th style="padding: 3px 3px; background: ${pdfHeaderBgColor}; color: ${pdfTextColor}; font-weight: 600; text-align: center; border: 0.5px solid ${pdfBorderColor};"><span style="font-size: 5px;">${lowStockAlertLabel}</span></th>
                                        <th style="padding: 3px 3px; background: ${pdfHeaderBgColor}; color: ${pdfTextColor}; font-weight: 600; text-align: center; border: 0.5px solid ${pdfBorderColor};"><span style="font-size: 5px;">${expiryLabel}</span></th>
                                        <th style="padding: 3px 3px; background: ${pdfHeaderBgColor}; color: ${pdfTextColor}; font-weight: 600; text-align: center; border: 0.5px solid ${pdfBorderColor};"><span style="font-size: 5px;">${stockStatusLabel}</span></th>
                                        <th style="padding: 3px 3px; background: ${pdfHeaderBgColor}; color: ${pdfTextColor}; font-weight: 600; text-align: center; border: 0.5px solid ${pdfBorderColor};"><span style="font-size: 5px;">${stockValueLabel}</span></th>
                                        <th style="padding: 3px 3px; background: ${pdfHeaderBgColor}; color: ${pdfTextColor}; font-weight: 600; text-align: center; border: 0.5px solid ${pdfBorderColor};"><span style="font-size: 5px;">${addedByLabel}</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                        `;

                        pageProducts.forEach((product, idx) => {
                            const rowNum = startRowIndex + idx + 1;
                            const isEven = idx % 2 === 0;

                            const totalQty = parseFloat(product.quantity || 0);
                            const alertQty = parseFloat(product.quantity_alert || 0);
                            const sellPerUnit = parseFloat(product.sell_price_per_unit || 0);

                            // FIXED: Get cost per unit with fallbacks
                            const costPerUnit = parseFloat(
                                product.cost_per_unit ||
                                product.costPerUnit ||
                                product.unit_cost ||
                                (product.cost_per_pack / (product.items_per_pack || 1)) ||
                                0
                            );

                            const sellPerPack = parseFloat(product.sell_per_pack || 0);

                            // FIXED: Stock Value = cost/unit * total quantity
                            const stockValue = costPerUnit * totalQty;

                            let stockStatus = '';
                            let stockStatusColor = '';
                            if (totalQty <= 0) {
                                stockStatus = getPDFTranslation('outOfStock', 'Out of Stock');
                                stockStatusColor = '#ef4444';
                            } else if (totalQty <= alertQty) {
                                stockStatus = getPDFTranslation('lowStock', 'Low Stock');
                                stockStatusColor = '#f59e0b';
                            } else {
                                stockStatus = getPDFTranslation('inStock', 'In Stock');
                                stockStatusColor = '#10b981';
                            }

                            const expiryDate = product.expiry_date ? formatDateGlobal(product.expiry_date) : '-';

                            tableHTML += `
                                <tr style="border-bottom: 0.5px solid ${pdfBorderColor}; background: ${isEven ? pdfRowEvenBg : pdfRowOddBg};">
                                    <td style="padding: 2px 2px; text-align: center; color: ${pdfSubTextColor}; border-right: 0.5px solid ${pdfBorderColor};">${rowNum}</td>
                                    <td style="padding: 2px 2px; text-align: ${isRTL ? 'right' : 'left'}; color: ${pdfTextColor}; font-weight: 500; border-right: 0.5px solid ${pdfBorderColor};">${escapeHtml(product.product_name) || '-'}</td>
                                    <td style="padding: 2px 2px; text-align: center; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; font-family: monospace;">${escapeHtml(product.batch_no) || '-'}</td>
                                    <td style="padding: 2px 2px; text-align: center; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; font-family: monospace;">${escapeHtml(product.barcode) || '-'}</td>
                                    <td style="padding: 2px 2px; text-align: center; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor};">${escapeHtml(product.company) || '-'}</td>
                                    <td style="padding: 2px 2px; text-align: center; color: #7c3aed; border-right: 0.5px solid ${pdfBorderColor};">Rs. ${costPerUnit.toFixed(2)}</td>
                                    <td style="padding: 2px 2px; text-align: center; color: #059669; border-right: 0.5px solid ${pdfBorderColor};">Rs. ${sellPerUnit.toFixed(2)}</td>
                                    <td style="padding: 2px 2px; text-align: center; color: #0d9488; border-right: 0.5px solid ${pdfBorderColor};">Rs. ${sellPerPack.toFixed(2)}</td>
                                    <td style="padding: 2px 2px; text-align: center; font-weight: 500; border-right: 0.5px solid ${pdfBorderColor}; ${totalQty <= 0 ? 'color: #dc2626;' : (totalQty <= alertQty ? 'color: #d97706;' : 'color: #333;')}">${totalQty.toFixed(2)}</td>
                                    <td style="padding: 2px 2px; text-align: center; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor};">${alertQty.toFixed(2)}</td>
                                    <td style="padding: 2px 2px; text-align: center; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor};">${expiryDate}</td>
                                    <td style="padding: 2px 2px; text-align: center; color: ${stockStatusColor}; border-right: 0.5px solid ${pdfBorderColor};">${stockStatus}</td>
                                    <td style="padding: 2px 2px; text-align: center; color: #8b5cf6; font-weight: 600; border-right: 0.5px solid ${pdfBorderColor};">Rs. ${stockValue.toFixed(2)}</td>
                                    <td style="padding: 2px 2px; text-align: center; color: ${pdfTextColor};">${escapeHtml(product.added_by_username || product.username || '-')}</td>
                                </tr>
                            `;
                        });

                        const emptyRowsNeeded = rowsPerPage - pageProducts.length;
                        for (let i = 0; i < emptyRowsNeeded; i++) {
                            tableHTML += `
                                <tr style="border-bottom: 0.5px solid ${pdfBorderColor}; background: ${(pageProducts.length + i) % 2 === 0 ? pdfRowEvenBg : pdfRowOddBg};">
                                    <td style="padding: 2px 2px; text-align: center; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 2px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 2px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 2px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 2px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 2px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 2px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 2px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 2px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 2px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 2px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 2px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 2px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 2px 2px;">&nbsp;</td>
                                </tr>
                            `;
                        }

                        tableHTML += `
                                </tbody>
                            </table>
                        `;

                        const footerHTML = `
                            <div style="margin-top: 8px; padding-top: 5px; text-align: center;">
                                <div style="width: 30px; height: 1px; background: ${pdfBorderColor}; margin: 0 auto 5px auto;"></div>
                                <div style="font-size: 6.5px; color: ${pdfSubTextColor};">${pageLabel} ${pageNum} ${ofLabel} ${totalPages}</div>
                            </div>
                        `;

                        container.innerHTML = headerHTML + filterHTML + tableHTML + footerHTML;
                        document.body.appendChild(container);
                        html2canvas(container, { scale: 2, backgroundColor: '#ffffff', logging: false }).then(canvas => {
                            document.body.removeChild(container);
                            resolve(canvas);
                        }).catch(err => { document.body.removeChild(container); reject(err); });
                    } catch (err) { reject(err); }
                });
            };

            for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
                const startRow = (pageNum - 1) * rowsPerPage;
                const endRow = Math.min(pageNum * rowsPerPage, productsToExport.length);
                const pageProducts = productsToExport.slice(startRow, endRow);
                const canvas = await renderPage(pageProducts, pageNum, startRow);
                if (pageNum > 1) {
                    pdf.addPage();
                }
                const imgWidth = pageWidth - 20;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;
                pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 10, 5, imgWidth, imgHeight);
            }

            const fileName = `Product_Report_${currentShop?.shop_name?.replace(/[^a-z0-9]/gi, '_') || 'Export'}_${currentDateGlobal()}.pdf`;
            pdf.save(fileName);
            showToast('success', `${translations.reportGenerated || 'Report generated!'} ${productsToExport.length} ${translations.products || 'products'} on ${totalPages} ${translations.pages || 'page(s)'}`);
        } catch (error) {
            console.error('PDF Error:', error);
            showToast('error', translations.pdfGenerationError || 'Error generating PDF');
        } finally {
            setPdfLoading(false);
        }
    }, [filteredProducts, currentLanguage, pdfOrientation, pdfPageSize, pdfPageRange, pdfStartPage, pdfEndPage, translations, businessInfo, currentShop, user, showToast, getRowsPerPage, searchTerm, categoryFilter, companyFilter, colorFilter, sizeFilter, startDate, endDate, currentTheme]);

    const handleView = useCallback((product) => { setSelectedProduct(product); setShowViewModal(true); }, []);

    const handleEdit = useCallback((product) => {
        if (product.username !== user?.username) {
            showToast('error', 'You can only edit your own product records');
            return;
        }
        setSelectedProduct(product);
        setEditFormData({
            product_name: product.product_name || '',
            batch_no: product.batch_no || '',
            barcode: product.barcode || '',
            company: product.company || '',
            cost_price_per_pack: product.cost_per_pack || '',
            sell_price_per_unit: product.sell_price_per_unit || '',
            total_quantity: product.quantity || '',
            quantity_alert: product.quantity_alert || '1',
            expiry_date: product.expiry_date ? product.expiry_date.split('T')[0] : '',
            cost_per_unit: product.cost_per_unit || '',
            sell_per_pack: product.sell_per_pack || '',
            packing_type: product.packing_type || 'packet',
            sub_packing_type: product.sub_packing_type || 'piece',
            items_per_pack: product.items_per_pack || '1',
            unit_of_measure: product.unit_of_measure || 'piece',
            category: product.category || '',
            color: product.color || '',
            size: product.size || ''
        });
        setEditFormErrors({});
        setShowEditModal(true);
    }, [user, showToast]);

    const handleDeleteClick = useCallback((productId) => {
        const product = products.find(p => p.id === productId);
        if (!product) return;
        if (product.username !== user?.username) {
            showToast('error', 'You can only delete products you added');
            return;
        }
        setProductToDelete(productId);
        setShowDeleteModal(true);
    }, [products, user, showToast]);

    const handleDelete = useCallback(async () => {
        if (!productToDelete || !currentShop) return;
        const product = products.find(p => p.id === productToDelete);
        if (!product || product.username !== user?.username) {
            showToast('error', 'You can only delete your own products');
            setShowDeleteModal(false);
            setProductToDelete(null);
            return;
        }
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/cosmetics_module/cosmetics_products.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'delete',
                    id: productToDelete,
                    username: user.username,
                    shop_id: currentShop.shop_id
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                showToast('success', translations.deletedSuccess || 'Product deleted successfully');
                fetchProducts();
                setShowDeleteModal(false);
                setProductToDelete(null);
            } else {
                showToast('error', data.message || translations.deleteError || 'Error deleting product');
            }
        } catch (error) {
            console.error('Error deleting product:', error);
            showToast('error', translations.deleteError || 'Error deleting product');
        }
    }, [productToDelete, currentShop, products, user, translations, showToast, fetchProducts]);

    const validateEditForm = () => {
        const errors = {};
        if (!editFormData.product_name?.trim()) errors.product_name = translations.nameRequired || 'Product name is required';
        if (!editFormData.batch_no?.trim()) errors.batch_no = translations.batchRequired || 'Batch number is required';

        const costPrice = parseFloat(editFormData.cost_price_per_pack);
        if (isNaN(costPrice) || costPrice < 0) errors.cost_price_per_pack = translations.costPriceRequired || 'Cost price is required';

        const sellPrice = parseFloat(editFormData.sell_price_per_unit);
        if (isNaN(sellPrice) || sellPrice < 0) errors.sell_price_per_unit = translations.sellingPriceRequired || 'Selling price is required';

        const quantity = parseFloat(editFormData.total_quantity);
        if (isNaN(quantity) || quantity < 0) errors.total_quantity = translations.quantityRequired || 'Quantity is required';

        const alertQty = parseFloat(editFormData.quantity_alert);
        if (isNaN(alertQty) || alertQty < 0) errors.quantity_alert = translations.alertRequired || 'Low stock alert quantity is required';

        if (editFormData.expiry_date) {
            const expiry = new Date(editFormData.expiry_date);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (expiry < today) errors.expiry_date = translations.expiryPast || 'Expiry date cannot be in the past';
        }
        setEditFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    // ============================================
    // FIXED: handleUpdateProduct - Correct field mapping
    // ============================================
    const handleUpdateProduct = useCallback(async (e) => {
    e.preventDefault();
    if (!selectedProduct || !currentShop) {
        showToast('error', 'Product or shop information missing');
        return;
    }
    if (selectedProduct.username !== user?.username) {
        showToast('error', 'You can only update your own product records');
        return;
    }
    if (!validateEditForm()) return;
    setEditLoading(true);
    try {
        // Get values from form
        const costPerPack = parseFloat(editFormData.cost_price_per_pack) || 0;
        const sellPricePerUnit = parseFloat(editFormData.sell_price_per_unit) || 0;
        const totalQuantity = parseFloat(editFormData.total_quantity) || 0;
        const alertQuantity = parseFloat(editFormData.quantity_alert) || 1;
        
        // Get packing values from selected product or form
        const itemsPerPack = parseFloat(selectedProduct.items_per_pack) || 1;
        const unitOfMeasure = selectedProduct.unit_of_measure || 'piece';

        // Build update data
        const updateData = {
            id: selectedProduct.id,
            shop_id: currentShop.shop_id,
            username: user.username,
            // Basic product info
            product_name: editFormData.product_name.trim(),
            product_code: selectedProduct.product_code || '',
            category: editFormData.category || selectedProduct.category || '',
            company: editFormData.company.trim() || selectedProduct.company || '',
            color: editFormData.color || selectedProduct.color || '',
            size: editFormData.size || selectedProduct.size || '',
            barcode: editFormData.barcode || selectedProduct.barcode || '',
            // Quantity fields
            quantity: totalQuantity,
            quantity_alert: alertQuantity,
            expiry_date: editFormData.expiry_date || selectedProduct.expiry_date || null,
            // Cost and price fields
            cost_price_per_pack: costPerPack,
            sell_price_per_unit: sellPricePerUnit,
            // Packing fields
            packing_type: selectedProduct.packing_type || 'packet',
            sub_packing_type: selectedProduct.sub_packing_type || 'piece',
            items_per_pack: itemsPerPack,
            unit_of_measure: unitOfMeasure
        };

        console.log('Sending update data to editproducts.php:', updateData);

        // USE THE NEW editproducts.php ENDPOINT
        const response = await fetch('https://ourzestapp.online/oz_backend/cosmetics_module/editproducts.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updateData)
        });

        const responseText = await response.text();
        let data;
        try {
            data = JSON.parse(responseText);
        } catch (jsonError) {
            console.error('JSON Parse Error. Raw response:', responseText);
            throw new Error('Invalid JSON response from server');
        }

        if (data.status === 'success') {
            showToast('success', translations.productUpdated || 'Product updated successfully');
            fetchProducts();
            setShowEditModal(false);
            setSelectedProduct(null);
        } else {
            console.error('Server error response:', data);
            showToast('error', data.message || translations.updateError || 'Error updating product');
        }
    } catch (error) {
        console.error('Error updating product:', error);
        showToast('error', error.message || translations.updateError || 'Error updating product');
    } finally {
        setEditLoading(false);
    }
}, [selectedProduct, currentShop, editFormData, user, translations, showToast, fetchProducts, validateEditForm]);

    const handlePageChange = useCallback((page) => { if (page >= 1 && page <= pagination.totalPages) setCurrentPage(page); }, [pagination.totalPages]);

    const getStockStatus = (quantity, alert) => {
        const qty = parseFloat(quantity) || 0;
        const alertQty = parseFloat(alert) || 0;
        if (qty <= 0) return { status: 'out-of-stock', text: translations.outOfStock || 'Out of Stock', color: '#ef4444' };
        if (qty <= alertQty) return { status: 'low-stock', text: translations.lowStock || 'Low Stock', color: '#f59e0b' };
        return { status: 'in-stock', text: translations.inStock || 'In Stock', color: '#10b981' };
    };

    const formatCurrency = (amount) => {
        if (!amount && amount !== 0) return '-';
        return `Rs. ${parseFloat(amount).toFixed(2)}`;
    };

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    return (
        <div className={`ozlistui-container ${isRTL ? 'ozlistui-rtl' : 'ozlistui-ltr'} ${darkMode ? 'ozlistui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            <ShopSelectorModal
                isOpen={showShopSelector}
                onClose={() => setShowShopSelector(false)}
                shops={availableShops}
                currentShop={currentShop}
                onSelectShop={handleSwitchShop}
                translations={translations}
                loading={loadingShops}
            />

            <div className="ozlistui-sticky-header">
                <div className="ozlistui-header-bg-animation">
                    <div className="gradient-orb orb-1"></div>
                    <div className="gradient-orb orb-2"></div>
                    <div className="gradient-orb orb-3"></div>
                    <div className="gradient-orb orb-4"></div>
                    <div className="gradient-orb orb-5"></div>
                </div>
                <div className="ozlistui-header-content">
                    <div className="ozlistui-header-left">
                        <div className="ozlistui-header-title">
                            <h1>{translations.productList || 'Products List'}</h1>
                            <p>{translations.formDetails || 'All products details are below'}</p>
                        </div>
                    </div>
                    <div className="ozlistui-header-right">
                        <button
                            className="ozlistui-header-filter-btn"
                            onClick={() => setShowFilters(!showFilters)}
                            title={showFilters ? "Hide Filters" : "Show Filters"}
                        >
                            <FontAwesomeIcon icon={showFilters ? faEyeSlash : faFilter} />
                            <span>{showFilters ? "Hide Filters" : "Filters"}</span>
                        </button>

                        {!currentShop && (
                            <button className="ozlistui-header-shop-btn" onClick={() => setShowShopSelector(true)}>
                                <FontAwesomeIcon icon={faExchangeAlt} />
                                <span>{translations.switchShop || 'Switch Shop'}</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {showFilters && (
                <div className="ozlistui-filters-section">
                    <div className="ozlistui-filters-row">
                        <CustomDropdown
                            label={translations.filterBy || 'Filter By'}
                            icon={faTag}
                            value={filterBy}
                            onChange={setFilterBy}
                            options={filterByOptions}
                            translations={translations}
                        />

                        {filterBy === 'productName' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="productNameFilter"
                                        value={productNameFilter}
                                        onChange={(e) => setProductNameFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="productNameFilter">
                                        <FontAwesomeIcon icon={faBox} />
                                        {translations.productNameFilter || 'Product Name'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'category' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="categoryFilter"
                                        value={categoryFilter}
                                        onChange={(e) => setCategoryFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="categoryFilter">
                                        <FontAwesomeIcon icon={faLayerGroup} />
                                        {translations.categoryFilter || 'Category'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'company' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="companyFilter"
                                        value={companyFilter}
                                        onChange={(e) => setCompanyFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="companyFilter">
                                        <FontAwesomeIcon icon={faBuilding} />
                                        {translations.companyFilter || 'Company Name'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'color' && (
                            <div className="ozlistui-filter-group">
                                <CustomDropdown
                                    label={translations.colorFilter || 'Color'}
                                    icon={faPalette}
                                    value={colorFilter}
                                    onChange={setColorFilter}
                                    options={colorOptions}
                                    translations={translations}
                                />
                            </div>
                        )}

                        {filterBy === 'size' && (
                            <div className="ozlistui-filter-group">
                                <CustomDropdown
                                    label={translations.sizeFilter || 'Size'}
                                    icon={faRulerCombined}
                                    value={sizeFilter}
                                    onChange={setSizeFilter}
                                    options={sizeOptions}
                                    translations={translations}
                                />
                            </div>
                        )}

                        {filterBy === 'batch' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="batchFilter"
                                        value={batchFilter}
                                        onChange={(e) => setBatchFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="batchFilter">
                                        <FontAwesomeIcon icon={faHashtag} />
                                        {translations.batchFilter || 'Batch Number'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'barcode' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="barcodeFilter"
                                        value={barcodeFilter}
                                        onChange={(e) => setBarcodeFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="barcodeFilter">
                                        <FontAwesomeIcon icon={faBarcode} />
                                        {translations.barcodeFilter || 'Barcode'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'added_by' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="addedByFilter"
                                        value={addedByFilter}
                                        onChange={(e) => setAddedByFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="addedByFilter">
                                        <FontAwesomeIcon icon={faUser} />
                                        {translations.addedByFilter || 'Added By'}
                                    </label>
                                </div>
                            </div>
                        )}

                        <CustomDropdown
                            label={translations.stockStatus || 'Stock Status'}
                            icon={faExclamationTriangle}
                            value={stockStatusFilter}
                            onChange={setStockStatusFilter}
                            options={stockStatusOptions}
                            translations={translations}
                        />

                        <CustomDropdown
                            label={translations.orientation || 'Orientation'}
                            icon={faFilePdf}
                            value={pdfOrientation}
                            onChange={setPdfOrientation}
                            options={pdfOrientationOptions}
                            translations={translations}
                        />

                        <CustomDropdown
                            label={translations.pageSize || 'Page Size'}
                            icon={faFilePdf}
                            value={pdfPageSize}
                            onChange={setPdfPageSize}
                            options={pdfPageSizeOptions}
                            translations={translations}
                        />

                        <div className="ozlistui-filter-group">
                            <button onClick={fetchProducts} className="ozlistui-refresh-btn" disabled={loading}>
                                <FontAwesomeIcon icon={faRefresh} />
                                <span className="ozlistui-btn-text">{translations.refresh || 'Refresh'}</span>
                            </button>
                        </div>

                        <div className="ozlistui-filter-group">
                            <button
                                onClick={exportToPDF}
                                className="ozlistui-refresh-btn"
                                disabled={filteredProducts.length === 0 || pdfLoading}
                                style={{ background: 'linear-gradient(135deg, #dc2626, #b91c1c)', color: 'white' }}
                            >
                                {pdfLoading ? <div className="ozlistui-btn-spinner-small"></div> : <FontAwesomeIcon icon={faFilePdf} />}
                                <span className="ozlistui-btn-text">{translations.exportToPDF || 'Export PDF'}</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {loading ? (
                <div className="ozlistui-loading-container">
                    <div className="ozlistui-loading-spinner"></div>
                    <p>{translations.loadingUserData || 'Loading your product data...'}</p>
                </div>
            ) : !currentShop ? (
                <div className="ozlistui-no-shop-container">
                    <div className="ozlistui-no-shop-message">
                        <FontAwesomeIcon icon={faStore} />
                        <h3>{translations.noShopSelected || 'No Shop Selected'}</h3>
                        <p>{translations.selectShop || 'Please select a shop to view products'}</p>
                        <button className="ozlistui-btn ozlistui-btn-primary" onClick={() => setShowShopSelector(true)}>
                            <FontAwesomeIcon icon={faExchangeAlt} />
                            <span>{translations.switchShop || 'Switch Shop'}</span>
                        </button>
                    </div>
                </div>
            ) : (
                <>
                    {/* Summary Cards */}
                    <div className="ozlistui-summary-cards">
                        <div className="ozlistui-summary-card">
                            <div className="ozlistui-summary-icon" style={{ background: '#3b82f620', color: '#3b82f6' }}>
                                <FontAwesomeIcon icon={faBoxes} />
                            </div>
                            <div className="ozlistui-summary-info">
                                <h3>{filteredProducts.length}</h3>
                                <p>{translations.totalProducts || 'Total Products'}</p>
                            </div>
                        </div>
                        <div className="ozlistui-summary-card">
                            <div className="ozlistui-summary-icon" style={{ background: '#10b98120', color: '#10b981' }}>
                                <FontAwesomeIcon icon={faCheckCircle} />
                            </div>
                            <div className="ozlistui-summary-info">
                                <h3>{filteredProducts.filter(p => { const q = parseFloat(p.quantity || 0); const a = parseFloat(p.quantity_alert || 0); return q > a; }).length}</h3>
                                <p>{translations.inStock || 'In Stock'}</p>
                            </div>
                        </div>
                        <div className="ozlistui-summary-card">
                            <div className="ozlistui-summary-icon" style={{ background: '#f59e0b20', color: '#f59e0b' }}>
                                <FontAwesomeIcon icon={faExclamationTriangle} />
                            </div>
                            <div className="ozlistui-summary-info">
                                <h3>{filteredProducts.filter(p => { const q = parseFloat(p.quantity || 0); const a = parseFloat(p.quantity_alert || 0); return q <= a && q > 0; }).length}</h3>
                                <p>{translations.lowStock || 'Low Stock'}</p>
                            </div>
                        </div>
                        <div className="ozlistui-summary-card">
                            <div className="ozlistui-summary-icon" style={{ background: '#ef444420', color: '#ef4444' }}>
                                <FontAwesomeIcon icon={faTimesCircle} />
                            </div>
                            <div className="ozlistui-summary-info">
                                <h3>{filteredProducts.filter(p => { const q = parseFloat(p.quantity || 0); return q <= 0; }).length}</h3>
                                <p>{translations.outOfStock || 'Out of Stock'}</p>
                            </div>
                        </div>
                        <div className="ozlistui-summary-card">
                            <div className="ozlistui-summary-icon" style={{ background: '#8b5cf620', color: '#8b5cf6' }}>
                                <FontAwesomeIcon icon={faCreditCard} />
                            </div>
                            <div className="ozlistui-summary-info">
                                <h3>{formatCurrency(totalStockValue)}</h3>
                                <p>{translations.stockValue || 'Stock Value'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="ozlistui-table-scroll">
                        <div className="ozlistui-table-container">
                            <div className="ozlistui-table-wrapper">
                                <table className="ozlistui-table">
                                    <thead>
                                        <tr>
                                            <th className="ozlistui-id-column ozlistui-centered-cell">{translations.serialNo || 'S.No'}</th>
                                            <th className="ozlistui-centered-cell">{translations.productName || 'Product Name'}</th>
                                            <th className="ozlistui-centered-cell">{translations.batchNumber || 'Batch'}</th>
                                            <th className="ozlistui-centered-cell">{translations.barcode || 'Barcode'}</th>
                                            <th className="ozlistui-centered-cell">{translations.category || 'Category'}</th>
                                            <th className="ozlistui-centered-cell">{translations.costPerUnit || 'Cost/Unit'}</th>
                                            <th className="ozlistui-centered-cell">{translations.sellPerUnit || 'Price/Unit'}</th>
                                            <th className="ozlistui-centered-cell">{translations.totalQuantity || 'Qty'}</th>
                                            <th className="ozlistui-centered-cell">{translations.lowStockAlert || 'Alert'}</th>
                                            <th className="ozlistui-centered-cell">{translations.expiryDate || 'Expiry'}</th>
                                            <th className="ozlistui-centered-cell">{translations.stockStatus || 'Status'}</th>
                                            <th className="ozlistui-centered-cell">{translations.stockValue || 'Stock Value'}</th>
                                            <th className="ozlistui-actions-column ozlistui-centered-cell">{translations.actions || 'Actions'}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pagination.currentProducts.map((product, index) => {
                                            const addedBy = product.added_by_username || product.username || '-';
                                            const isSelfAdded = addedBy === user?.username;
                                            const stockStatus = getStockStatus(product.quantity, product.quantity_alert);

                                            // FIXED: Get cost per unit with fallbacks
                                            const costPerUnit = parseFloat(
                                                product.cost_per_unit ||
                                                product.costPerUnit ||
                                                product.unit_cost ||
                                                (product.cost_per_pack / (product.items_per_pack || 1)) ||
                                                0
                                            );
                                            const totalQty = parseFloat(product.quantity || 0);
                                            // FIXED: Stock Value = cost/unit * total quantity
                                            const stockValue = costPerUnit * totalQty;

                                            return (
                                                <tr key={product.id}>
                                                    <td className="ozlistui-id-cell ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{pagination.startIndex + index + 1}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text ozlistui-product-name">{product.product_name || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{product.batch_no || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{product.barcode || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{product.category || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{formatCurrency(costPerUnit)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{formatCurrency(product.sell_price_per_unit)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className={`ozlistui-cell-text ${stockStatus.status === 'low-stock' ? 'ozlistui-low-stock' : stockStatus.status === 'out-of-stock' ? 'ozlistui-out-of-stock' : ''}`}>
                                                            {parseFloat(product.quantity || 0).toFixed(2)}
                                                        </span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{parseFloat(product.quantity_alert || 0).toFixed(2)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{formatDate(product.expiry_date)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-stock-badge" style={{ backgroundColor: stockStatus.color + '20', color: stockStatus.color }}>
                                                            {stockStatus.text}
                                                        </span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text" style={{ color: '#8b5cf6', fontWeight: 'bold' }}>
                                                            {formatCurrency(stockValue)}
                                                        </span>
                                                    </td>
                                                    <td className="ozlistui-actions-cell ozlistui-centered-cell">
                                                        <div className="ozlistui-actions-content">
                                                            <button onClick={() => handleView(product)} className="ozlistui-action-btn ozlistui-view-btn" title={translations.view || 'View'}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </button>
                                                            <button onClick={() => handleEdit(product)} className="ozlistui-action-btn ozlistui-edit-btn" title={translations.edit || 'Edit'}>
                                                                <FontAwesomeIcon icon={faEdit} />
                                                            </button>
                                                            <button onClick={() => handleDeleteClick(product.id)} className="ozlistui-action-btn ozlistui-delete-btn" title={translations.delete || 'Delete'} disabled={!isSelfAdded} style={{ opacity: isSelfAdded ? 1 : 0.5, cursor: isSelfAdded ? 'pointer' : 'not-allowed' }}>
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {filteredProducts.length > 0 && currentShop && (
                        <div className="ozlistui-pagination">
                            <div className="ozlistui-pagination-info">
                                <span>{translations.showing || 'Showing'} {pagination.startIndex + 1} {translations.of || 'of'} {filteredProducts.length} {translations.products || 'products'}</span>
                            </div>
                            <div className="ozlistui-pagination-controls">
                                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="ozlistui-pagination-btn">
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                    <span>{translations.previous || 'Previous'}</span>
                                </button>
                                <div className="ozlistui-page-numbers">
                                    {Array.from({ length: Math.min(5, pagination.totalPages) }, (_, i) => {
                                        let pageNum;
                                        if (pagination.totalPages <= 5) {
                                            pageNum = i + 1;
                                        } else if (currentPage <= 3) {
                                            pageNum = i + 1;
                                        } else if (currentPage >= pagination.totalPages - 2) {
                                            pageNum = pagination.totalPages - 4 + i;
                                        } else {
                                            pageNum = currentPage - 2 + i;
                                        }
                                        return (
                                            <button key={pageNum} onClick={() => handlePageChange(pageNum)} className={`ozlistui-page-number ${currentPage === pageNum ? 'ozlistui-active' : ''}`}>
                                                {pageNum}
                                            </button>
                                        );
                                    })}
                                </div>
                                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === pagination.totalPages} className="ozlistui-pagination-btn">
                                    <span>{translations.next || 'Next'}</span>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                        </div>
                    )}
                </>
            )}

            {/* View Modal */}
            {showViewModal && selectedProduct && (
                <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
                    <div className="ozlistui-modal-content ozlistui-view-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="ozlistui-modal-header">
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faBox} /></div>
                            <div className="ozlistui-modal-title">
                                <h3>{translations.productDetails || 'Product Details'}</h3>
                                <span className="ozlistui-product-number-badge">#{selectedProduct.id}</span>
                            </div>
                            <button className="ozlistui-close-btn" onClick={() => setShowViewModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="ozlistui-modal-body ozlistui-view-modal-body">
                            <div className="ozlistui-view-section">
                                <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faBox} />{translations.productDetails || 'Product Summary'}</h4>
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.productName || 'Product Name'}:</span><span className="ozlistui-view-value">{selectedProduct.product_name || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.batchNumber || 'Batch Number'}:</span><span className="ozlistui-view-value">{selectedProduct.batch_no || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.barcode || 'Barcode'}:</span><span className="ozlistui-view-value">{selectedProduct.barcode || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.category || 'Category'}:</span><span className="ozlistui-view-value">{selectedProduct.category || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.company || 'Company'}:</span><span className="ozlistui-view-value">{selectedProduct.company || '-'}</span></div>
                                </div>
                            </div>
                            <div className="ozlistui-view-section">
                                <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faCreditCard} />{translations.stockInfo || 'Stock Information'}</h4>
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.costPerUnit || 'Cost Per Unit'}:</span><span className="ozlistui-view-value">{formatCurrency(selectedProduct.cost_per_unit)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.sellPerUnit || 'Sell Price Per Unit'}:</span><span className="ozlistui-view-value">{formatCurrency(selectedProduct.sell_price_per_unit)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.sellPerPack || 'Sell Price Per Pack'}:</span><span className="ozlistui-view-value">{formatCurrency(selectedProduct.sell_per_pack)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.totalQuantity || 'Total Quantity'}:</span><span className="ozlistui-view-value">{parseFloat(selectedProduct.quantity || 0).toFixed(2)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.lowStockAlert || 'Low Stock Alert'}:</span><span className="ozlistui-view-value">{parseFloat(selectedProduct.quantity_alert || 0).toFixed(2)}</span></div>
                                    {selectedProduct.expiry_date && (
                                        <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.expiryDate || 'Expiry Date'}:</span><span className="ozlistui-view-value">{formatDate(selectedProduct.expiry_date)}</span></div>
                                    )}
                                    {(() => {
                                        // FIXED: Get cost per unit with fallbacks
                                        const costPerUnit = parseFloat(
                                            selectedProduct.cost_per_unit ||
                                            selectedProduct.costPerUnit ||
                                            selectedProduct.unit_cost ||
                                            (selectedProduct.cost_per_pack / (selectedProduct.items_per_pack || 1)) ||
                                            0
                                        );
                                        const totalQty = parseFloat(selectedProduct.quantity || 0);
                                        // FIXED: Stock Value = cost/unit * total quantity
                                        const stockVal = costPerUnit * totalQty;
                                        return (
                                            <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.stockValue || 'Stock Value'}:</span><span className="ozlistui-view-value" style={{ color: '#8b5cf6', fontWeight: 'bold' }}>{formatCurrency(stockVal)}</span></div>
                                        );
                                    })()}
                                </div>
                            </div>
                            <div className="ozlistui-view-section ozlistui-metadata-section">
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.addedBy || 'Added By'}:</span><span className="ozlistui-view-value"><span className="ozlistui-added-by-badge">{selectedProduct.added_by_username || selectedProduct.username || '-'}</span></span></div>
                                    {selectedProduct.date && (
                                        <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.dateAdded || 'Date Added'}:</span><span className="ozlistui-view-value">{formatDate(selectedProduct.date)}</span></div>
                                    )}
                                    {selectedProduct.shop_name && (
                                        <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.shopInfo || 'Shop'}:</span><span className="ozlistui-view-value">{selectedProduct.shop_name}</span></div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="ozlistui-modal-footer">
                            <button className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowViewModal(false)}>{translations.close || 'Close'}</button>
                            <button className="ozlistui-btn ozlistui-btn-primary" onClick={() => { setShowViewModal(false); handleEdit(selectedProduct); }}>
                                <FontAwesomeIcon icon={faEdit} />
                                {translations.edit || 'Edit'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Modal */}
            {showEditModal && selectedProduct && (
                <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
                    <div
                        ref={modalRef}
                        className="ozlistui-modal-content ozlistui-edit-modal-content"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: 'fixed',
                            left: modalPosition.x || '50%',
                            top: modalPosition.y || '50%',
                            transform: modalPosition.x === 0 && modalPosition.y === 0 ? 'translate(-50%, -50%)' : 'none',
                            width: modalSize.width,
                            minWidth: '350px',
                            maxWidth: '95vw',
                            maxHeight: '85vh'
                        }}
                    >
                        <div className="ozlistui-resize-handle-top" onMouseDown={(e) => startResize(e, 'n')}></div>
                        <div className="ozlistui-resize-handle-bottom" onMouseDown={(e) => startResize(e, 's')}></div>
                        <div className="ozlistui-resize-handle-left" onMouseDown={(e) => startResize(e, 'w')}></div>
                        <div className="ozlistui-resize-handle-right" onMouseDown={(e) => startResize(e, 'e')}></div>
                        <div className="ozlistui-resize-handle-nw" onMouseDown={(e) => startResize(e, 'nw')}></div>
                        <div className="ozlistui-resize-handle-ne" onMouseDown={(e) => startResize(e, 'ne')}></div>
                        <div className="ozlistui-resize-handle-sw" onMouseDown={(e) => startResize(e, 'sw')}></div>
                        <div className="ozlistui-resize-handle-se" onMouseDown={(e) => startResize(e, 'se')}></div>

                        <div className="ozlistui-modal-header" onMouseDown={startDrag}>
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faEdit} /></div>
                            <div className="ozlistui-modal-title">
                                <h3>{translations.editProduct || 'Edit Product'}</h3>
                                <span className="ozlistui-product-number-badge">#{selectedProduct.id}</span>
                            </div>
                            <div className="ozlistui-width-control-group">
                                {Object.entries(widthModes).map(([key, mode]) => (
                                    <button key={key} className={`ozlistui-width-btn ${currentWidthMode === key ? 'ozlistui-active' : ''}`} onClick={() => setWidthMode(key)} title={mode.label}>
                                        <FontAwesomeIcon icon={mode.icon} />
                                    </button>
                                ))}
                            </div>
                            <button className="ozlistui-close-btn" onClick={() => setShowEditModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <form onSubmit={handleUpdateProduct}>
                            <div className="ozlistui-modal-body">
                                <div className="ozlistui-form-grid">
                                    <div className={`ozlistui-form-group ${editFormErrors.product_name ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_product_name"
                                                name="product_name"
                                                value={editFormData.product_name}
                                                onChange={(e) => setEditFormData({ ...editFormData, product_name: e.target.value })}
                                                placeholder=" "
                                                className={editFormErrors.product_name ? 'ozlistui-error' : ''}
                                            />
                                            <label htmlFor="edit_product_name">
                                                <FontAwesomeIcon icon={faBox} />
                                                {translations.productName || 'Product Name'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.product_name && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.product_name}
                                            </div>
                                        )}
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.batch_no ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_batch_no"
                                                name="batch_no"
                                                value={editFormData.batch_no}
                                                onChange={(e) => setEditFormData({ ...editFormData, batch_no: e.target.value })}
                                                placeholder=" "
                                                readOnly={selectedProduct.username !== user?.username}
                                                style={selectedProduct.username !== user?.username ? { backgroundColor: '#f3f4f6', cursor: 'not-allowed' } : {}}
                                            />
                                            <label htmlFor="edit_batch_no">
                                                <FontAwesomeIcon icon={faHashtag} />
                                                {translations.batchNumber || 'Batch Number'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.batch_no && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.batch_no}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_barcode"
                                                name="barcode"
                                                value={editFormData.barcode}
                                                onChange={(e) => setEditFormData({ ...editFormData, barcode: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_barcode">
                                                <FontAwesomeIcon icon={faBarcode} />
                                                {translations.barcode || 'Barcode'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.cost_price_per_pack ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                step="0.01"
                                                id="edit_cost_price_per_pack"
                                                name="cost_price_per_pack"
                                                value={editFormData.cost_price_per_pack}
                                                onChange={(e) => setEditFormData({ ...editFormData, cost_price_per_pack: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_cost_price_per_pack">
                                                <FontAwesomeIcon icon={faCreditCard} />
                                                {translations.costPerPack || 'Cost Per Pack'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.cost_price_per_pack && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.cost_price_per_pack}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_cost_per_unit"
                                                name="cost_per_unit"
                                                value={editFormData.cost_per_unit}
                                                readOnly
                                                className="ozlistui-readonly"
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_cost_per_unit">
                                                <FontAwesomeIcon icon={faCreditCard} />
                                                {translations.costPerUnit || 'Cost Per Unit'}
                                                <span> (Auto-calculated)</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.sell_price_per_unit ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                step="0.01"
                                                id="edit_sell_price_per_unit"
                                                name="sell_price_per_unit"
                                                value={editFormData.sell_price_per_unit}
                                                onChange={(e) => setEditFormData({ ...editFormData, sell_price_per_unit: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_sell_price_per_unit">
                                                <FontAwesomeIcon icon={faTag} />
                                                {translations.sellPerUnit || 'Sell Price Per Unit'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.sell_price_per_unit && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.sell_price_per_unit}
                                            </div>
                                        )}
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.total_quantity ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                step="0.001"
                                                id="edit_total_quantity"
                                                name="total_quantity"
                                                value={editFormData.total_quantity}
                                                onChange={(e) => setEditFormData({ ...editFormData, total_quantity: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_total_quantity">
                                                <FontAwesomeIcon icon={faWarehouse} />
                                                {translations.totalQuantity || 'Total Quantity'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.total_quantity && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.total_quantity}
                                            </div>
                                        )}
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.quantity_alert ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                step="0.001"
                                                id="edit_quantity_alert"
                                                name="quantity_alert"
                                                value={editFormData.quantity_alert}
                                                onChange={(e) => setEditFormData({ ...editFormData, quantity_alert: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_quantity_alert">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {translations.lowStockAlert || 'Low Stock Alert'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.quantity_alert && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.quantity_alert}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="date"
                                                id="edit_expiry_date"
                                                name="expiry_date"
                                                value={editFormData.expiry_date}
                                                onChange={(e) => setEditFormData({ ...editFormData, expiry_date: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_expiry_date">
                                                <FontAwesomeIcon icon={faCalendar} />
                                                {translations.expiryDate || 'Expiry Date'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                        {editFormErrors.expiry_date && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.expiry_date}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="ozlistui-modal-footer">
                                <button type="button" className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowEditModal(false)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                    {translations.cancel || 'Cancel'}
                                </button>
                                <button type="submit" className="ozlistui-btn ozlistui-btn-primary" disabled={editLoading}>
                                    {editLoading ? (
                                        <>
                                            <div className="ozlistui-btn-spinner"></div>
                                            <span>{translations.updating || 'Updating...'}</span>
                                        </>
                                    ) : (
                                        <>
                                            <FontAwesomeIcon icon={faSave} />
                                            <span>{translations.saveChanges || 'Save Changes'}</span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
                    <div className="ozlistui-modal-content ozlistui-delete-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="ozlistui-modal-header ozlistui-delete-header">
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faExclamationTriangle} /></div>
                            <div className="ozlistui-modal-title"><h3>{translations.confirmDelete || 'Confirm Delete'}</h3></div>
                            <button className="ozlistui-close-btn" onClick={() => setShowDeleteModal(false)}><FontAwesomeIcon icon={faTimes} /></button>
                        </div>
                        <div className="ozlistui-modal-body">
                            <div className="ozlistui-delete-message">
                                <p>{translations.deleteMessage || 'Are you sure you want to delete this product?'}</p>
                                <p><FontAwesomeIcon icon={faExclamationTriangle} /> {translations.deleteWarning || 'This action cannot be undone.'}</p>
                            </div>
                        </div>
                        <div className="ozlistui-modal-footer">
                            <button type="button" className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowDeleteModal(false)}><FontAwesomeIcon icon={faTimes} />{translations.noCancel || 'No, Cancel'}</button>
                            <button type="button" className="ozlistui-btn ozlistui-btn-delete" onClick={handleDelete}><FontAwesomeIcon icon={faTrash} />{translations.yesDelete || 'Yes, Delete'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SolarProductsList;